/*
 * minimal-coleccion.js — Página de colección minimal (Serené, estilo ZARA).
 * - Tabs COLECCIÓN / EDITORIAL sin recargar.
 * - Panel FILTRAR (Search & Discovery nativo): APLICAR envía el form, LIMPIAR resetea.
 * - Botón "+" de tarjeta: /cart/add.js + refresca y abre el cart-drawer del tema.
 * - Infinite scroll con IntersectionObserver; los banners siguen intercalándose.
 * Aislado, sin dependencias. No toca ninguna otra sección.
 */
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  var root = document.querySelector('[data-mc-root]');
  if (!root) return;

  var VIEW = new URLSearchParams(window.location.search).get('view');
  function withView(url) {
    if (!VIEW) return url;
    try {
      var u = new URL(url, window.location.origin);
      if (!u.searchParams.get('view')) u.searchParams.set('view', VIEW);
      return u.pathname + u.search;
    } catch (e) { return url; }
  }

  /* ============ 1. TABS COLECCIÓN / EDITORIAL ============ */
  var tabs = root.querySelectorAll('[data-mc-tab]');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var mode = tab.getAttribute('data-mc-tab');
      root.classList.toggle('is-editorial', mode === 'editorial');
      tabs.forEach(function (t) {
        var active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      var ed = root.querySelector('[data-mc-editorial]');
      if (ed) ed.hidden = mode !== 'editorial';
    });
  });

  /* ============ 2. FILTROS ============ */
  var filters = root.querySelector('[data-mc-filters]');
  var form = root.querySelector('[data-mc-filter-form]');

  function openFilters() {
    if (!filters) return;
    filters.hidden = false;
    // fuerza reflow para animar
    void filters.offsetWidth;
    filters.classList.add('is-open');
    document.body.classList.add('mc-no-scroll');
  }
  function closeFilters() {
    if (!filters) return;
    filters.classList.remove('is-open');
    document.body.classList.remove('mc-no-scroll');
    setTimeout(function () { filters.hidden = true; }, 260);
  }
  root.querySelectorAll('[data-mc-filter-open]').forEach(function (b) { b.addEventListener('click', openFilters); });
  root.querySelectorAll('[data-mc-filter-close]').forEach(function (b) { b.addEventListener('click', closeFilters); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && filters && filters.classList.contains('is-open')) closeFilters(); });

  // Preservar ?view= en preview (form + limpiar)
  if (VIEW && form) {
    if (!form.querySelector('input[name="view"]')) {
      var hv = document.createElement('input');
      hv.type = 'hidden'; hv.name = 'view'; hv.value = VIEW;
      form.appendChild(hv);
    }
    var clear = root.querySelector('[data-mc-filter-clear]');
    if (clear) clear.setAttribute('href', withView(clear.getAttribute('href')));
  }

  var apply = root.querySelector('[data-mc-filter-apply]');
  if (apply && form) apply.addEventListener('click', function () { form.submit(); });

  /* ============ 3. ADD TO CART (delegado) + CART DRAWER ============ */
  function refreshBubble(sections) {
    try {
      if (sections && sections['cart-icon-bubble']) {
        var p = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var t = document.getElementById('cart-icon-bubble');
        var s = p.querySelector('#shopify-section-cart-icon-bubble') || p.querySelector('.shopify-section');
        if (t && s) t.innerHTML = s.innerHTML;
      }
    } catch (e) {}
  }
  function updateDrawer(sections) {
    try {
      if (sections && sections['cart-drawer']) {
        var p = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var t = document.querySelector('cart-drawer');
        var s = p.querySelector('cart-drawer');
        if (t && s) {
          t.classList.toggle('is-empty', s.classList.contains('is-empty'));
          t.innerHTML = s.innerHTML;
        }
      }
    } catch (e) {}
  }
  function openDrawer() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') { d.open(); return true; }
    return false;
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-mc-add]') : null;
    if (!btn || !root.contains(btn)) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading') || btn.hasAttribute('disabled')) return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;

    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: id, quantity: 1,
        sections: 'cart-icon-bubble,cart-drawer',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function (data) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        refreshBubble(data.sections);
        updateDrawer(data.sections);
        if (!openDrawer()) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        setTimeout(function () { btn.classList.remove('is-added'); }, 2000);
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  });

  /* ============ 4. INFINITE SCROLL (intercalado se preserva) ============ */
  var stream = root.querySelector('[data-mc-stream]');
  var loadingMore = false;

  function loadNext(observerRef) {
    var lm = root.querySelector('[data-mc-loadmore]');
    if (!lm || loadingMore) return;
    var next = lm.getAttribute('data-next-url');
    if (!next) return;
    loadingMore = true;
    fetch(withView(next), { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newStream = doc.querySelector('[data-mc-stream]');
        if (newStream && stream) {
          while (newStream.firstChild) stream.appendChild(newStream.firstChild);
        }
        var newLm = doc.querySelector('[data-mc-loadmore]');
        if (newLm) {
          lm.setAttribute('data-next-url', newLm.getAttribute('data-next-url') || '');
          var btn = lm.querySelector('[data-mc-loadmore-btn]');
          var nbtn = newLm.querySelector('[data-mc-loadmore-btn]');
          if (btn && nbtn) btn.setAttribute('href', nbtn.getAttribute('href'));
          loadingMore = false;
          if (observerRef && lm.querySelector('[data-mc-sentinel]')) observerRef.observe(lm.querySelector('[data-mc-sentinel]'));
        } else {
          lm.parentNode && lm.parentNode.removeChild(lm);
          if (observerRef) observerRef.disconnect();
        }
      })
      .catch(function () { loadingMore = false; });
  }

  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { io.unobserve(entry.target); loadNext(io); }
      });
    }, { rootMargin: '600px 0px' });
    var sentinel = root.querySelector('[data-mc-sentinel]');
    if (sentinel) io.observe(sentinel);
  }
  // Fallback: click en VER MÁS
  root.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-mc-loadmore-btn]') : null;
    if (!b || !root.contains(b)) return;
    e.preventDefault();
    loadNext(io);
  });

  /* ============ 5. SEO leer más ============ */
  var seo = root.querySelector('[data-mc-seo]');
  if (seo) {
    var tgl = seo.querySelector('[data-mc-seo-toggle]');
    if (tgl) tgl.addEventListener('click', function () {
      var open = seo.classList.toggle('is-open');
      tgl.setAttribute('aria-expanded', open ? 'true' : 'false');
      tgl.textContent = open ? '− Leer menos' : '+ Leer más';
    });
  }
})();
